<template lang="pug">
.fam-card-view
  //.card-shadow
    img(src="~assets/card-shadow.png")
  blue-shadow  
  .card(ref="card")
    slot

</template>
<script>
import { mapGetters } from 'vuex'
import gsap from 'gsap'
import BlueShadow from '@/components/wedgits/BlueShadow3'
import AvatarAdult from '@/components/me/AvatarAdult'
export default {
  name: 'FamCardView',
  components: { BlueShadow },
  props: {
    active: {},
  },
  computed: {},
  data() {
    return {
      state: 0,
      clone: null,
    }
  },

  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.fam-card-view
  width: 100%
  height: 100%
//.card-shadow
  position: absolute
  width: pxToRem(612)
  height: pxToRem(190)
  left: pxToRem(-15)
  bottom: pxToRem(-60)
  z-index: -1
  opacity: 1
  img
    width: 100%
.card
  width: 100%
  height: 100%
  border-radius: pxToRem(16)
  overflow: hidden
  box-shadow: 0 pxToRem(-1) pxToRem(10) 0 rgba(226,226,226,0.73)
  background: #ffffff
  //transition: all 0.5s ease

@keyframes fadeIn
  0%
    transform: translateY(10%)
    opacity: 0
  100%
    transform: translateY(0)
    opacity: 1
</style>
